import {AnimatePresence} from 'framer-motion';
import {VFC} from 'react';
import {
  useHasPlayed,
  useIsPlaying,
  useIsPaused,
  useIsLoaded,
} from '../../hooks/usePlayerState';
import {usePlaybackToggle} from '../../hooks/usePlaybackToggle';
import {ControlButton} from '../controlButton';
import * as Styles from './bigPlayButton.styles';
import Icon from './icon.svg';

/**
 * Renders a large play button in the center of the video.
 * Also handles clicking the video to toggle playback.
 */
export const BigPlayButton: VFC = () => {
  const onClick = usePlaybackToggle();
  const isLoaded = useIsLoaded();
  const isPlaying = useIsPlaying();
  const isPaused = useIsPaused();
  const hasPlayed = useHasPlayed();

  if (!isLoaded) return null;

  return (
    <ControlButton
      ariaLabel={isPlaying ? 'Pause' : 'Play'}
      ariaPressed={!isPlaying}
      onClick={onClick}
      round={false}
      full
    >
      <AnimatePresence>
        {isPaused && !hasPlayed && (
          <Styles.IconWrapper
            key="bigPlayButton"
            initial={{opacity: 0, scale: 1.75}}
            animate={{opacity: 1, scale: 1}}
            exit={{opacity: [1, 0, 0, 0], scale: [1, 1.25, 1.5, 1.75]}}
            transition={{duration: 0.3, type: 'tween', ease: 'easeOut'}}
          >
            <Icon />
          </Styles.IconWrapper>
        )}
      </AnimatePresence>
    </ControlButton>
  );
};
